import Tokens from './Tokens';
import type { Icon } from './types';
import type SeatIconState from './SeatIconState';
import SyosConfig from '../SyosConfig';

function getColorReplacedContent(contents: string, color: string) {
  if (color) {
    return contents.replace(new RegExp(Tokens.iconBadgeFillColor, 'gm'), color);
  }

  return contents;
}

export interface IIconRenderer {
  getSvgMarkup: (icon: Icon, label: string, className?: string) => string;
  getSymbolMarkup: (seatIconState: SeatIconState) => string;
}

class IconRenderer implements IIconRenderer {
  badgeColors: { [key: string]: string; };

  constructor({ wheelchairSeatBadgeColor, specialSeatBadgeColor }: SyosConfig) {
    this.badgeColors = {
      wheelchair: wheelchairSeatBadgeColor,
      star: specialSeatBadgeColor,
    };
  }

  getSvgMarkup(icon: Icon, label: string, className?: string) {
    const contents = getColorReplacedContent(icon.contents, this.badgeColors[icon.name]);
    const classAttr = className ? `class="${className}"` : '';

    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="1 11 60 60" role="img" focusable="false" aria-label="${label}" ${classAttr}>${contents}</svg>`;
  }

  getSymbolMarkup({ icon, badge, id: symbol }: SeatIconState) {
    let badgeContent;

    if (badge) {
      badgeContent = getColorReplacedContent(badge.contents, this.badgeColors[badge.name]);
    } else {
      badgeContent = '';
    }

    return `<symbol id="${symbol}">${icon.contents}${badgeContent}</symbol>`;
  }
}

export default IconRenderer;
